import { Guid } from "guid-typescript";

import { IValidationIssue } from "infrastructure/validation";

import { IPlexTranslationMessageRow, IPlexTranslationMessageModifyData } from "./PlexTranslationMessages.state";

export const getPlexTranslationModifyData = (row: IPlexTranslationMessageRow, validationIssues: IValidationIssue[], translation?: string) => {
  let originalData = row.originalData;
  if (!originalData) {
    originalData = { ...row.data };
  }

  const data: IPlexTranslationMessageModifyData = {
    index: row.index,
    isTranslationChanged: row.isTranslationChanged,
    messageId: row.data.messageId || Guid.raw(),
    originalData: originalData,
    translatedText: translation,
    validationIssues: validationIssues
  };

  if (originalData) {
    if (originalData.translatedText === data.translatedText || (!originalData.translatedText && !data.translatedText)) {
      data.isTranslationChanged = false;
    } else {
      data.isTranslationChanged = true;
    }
  }

  return data;
};
